module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    staticStyle: {
      "min-width": "1280px"
    },
    attrs: {
      "title": "页面布局",
      "size": "large"
    }
  }, [(_vm.showConfig) ? _c('div', [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nodeValue),
      expression: "nodeValue"
    }],
    staticClass: "m-b-10",
    attrs: {
      "placeholder": "请选择复制的节点"
    },
    domProps: {
      "value": (_vm.nodeValue)
    },
    on: {
      "input": function($event) {
        _vm.nodeValue = $event
      }
    }
  }, _vm._l((_vm.modifyNode), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "m-b-10"
  }, [_c('el-button', {
    on: {
      "click": _vm.addFieldGroup
    }
  }, [_vm._v("添加分组")])]), _vm._v(" "), _c('div', {
    staticClass: "input-list bor-deep-gra ovf-auto m-b-20",
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    on: {
      "mouseover": function($event) {
        _vm.showInsertPos($event, -1)
      },
      "mouseup": function($event) {
        _vm.sortGroupUp($event)
      }
    }
  }, [_vm._l((_vm.fieldGroup), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.hide),
        expression: "!item.hide"
      }],
      staticClass: "bor-b-ccc",
      class: {
        'temp-group': item.temp
      },
      on: {
        "mouseenter": function($event) {
          _vm.showInsertPos($event, index)
        }
      }
    }, [(!item.temp) ? _c('div', [_c('div', {
      staticClass: "bor-b-gray"
    }, [_c('div', {
      staticClass: "inline-block drag-shank",
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "mousedown": function($event) {
          _vm.sortGroupDown($event, item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrows fz-24 c-blue"
    })]), _vm._v(" "), _c('div', {
      staticClass: "inline-block m-r-10"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "disabled": index == 0
      },
      on: {
        "click": function($event) {
          _vm.groupUp(index)
        }
      }
    }, [_vm._v("上移")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "disabled": index == _vm.fieldGroup.length - 1
      },
      on: {
        "click": function($event) {
          _vm.groupDown(index)
        }
      }
    }, [_vm._v("下移")])]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.group),
        expression: "item.group"
      }],
      staticClass: "w-200 m-r-10",
      attrs: {
        "placeholder": "分组名称"
      },
      domProps: {
        "value": (item.group)
      },
      on: {
        "input": function($event) {
          item.group = $event
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inline-block m-r-20"
    }, [_c('span', [_vm._v("布局：")]), _vm._v(" "), _c('el-radio-group', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.layout),
        expression: "item.layout"
      }],
      domProps: {
        "value": (item.layout)
      },
      on: {
        "input": function($event) {
          item.layout = $event
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 10
      }
    }, [_vm._v("一列")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 20
      }
    }, [_vm._v("两列")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 30
      }
    }, [_vm._v("三列")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 40
      }
    }, [_vm._v("四列")])])]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.needCondition),
        expression: "needCondition"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.showConditionListDialog(item)
        }
      }
    }, [_vm._v("可见条件")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.showDeleteConfirmDialog(index)
        }
      }
    }, [_vm._v("删除分组")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.showInputListDialog(item)
        }
      }
    }, [_vm._v("配置控件")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.saveOneGroup(item)
        }
      }
    }, [_vm._v("保存修改")])])]), _vm._v(" "), _c('input-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isSort),
        expression: "!isSort"
      }],
      attrs: {
        "field": item.inputs,
        "inputType": _vm.inputType,
        "inputTitle": _vm.inputTitle,
        "layout": item.layout
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _vm._v(" "), (_vm.isSort) ? _c('div', {
    staticClass: "pos-fixed sort-group",
    style: (_vm.styleObject)
  }, [_c('div', {
    staticClass: "bor-b-gray"
  }, [_c('div', {
    staticClass: "inline-block drag-shank",
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows fz-24 c-blue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-block m-r-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.index == 0
    }
  }, [_vm._v("上移")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.index == _vm.fieldGroup.length - 1
    }
  }, [_vm._v("下移")])]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curGroup.group),
      expression: "curGroup.group"
    }],
    staticClass: "w-200 m-r-10",
    attrs: {
      "placeholder": "分组名称"
    },
    domProps: {
      "value": (_vm.curGroup.group)
    },
    on: {
      "input": function($event) {
        _vm.curGroup.group = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inline-block m-r-20"
  }, [_c('span', [_vm._v("布局：")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curGroup.layout),
      expression: "curGroup.layout"
    }],
    domProps: {
      "value": (_vm.curGroup.layout)
    },
    on: {
      "input": function($event) {
        _vm.curGroup.layout = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("一列")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("两列")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 30
    }
  }, [_vm._v("三列")])])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("配置控件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("保存修改")])])])]) : _vm._e(), _vm._v(" ")], true), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelSetInput
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSetInput
    }
  }, [_vm._v("保存所有修改")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5236ed6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputConfig/inputConfig.vue
// module id = 1865
// module chunks = 2